import React from "react";
import { Link } from "react-router-dom";
import { Shield, Zap, Cloud, Server, CheckCircle } from "lucide-react";

export default function BaasDraas() {
  return (
    <div className="page-enter" data-testid="baas-page">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden" style={{ background: "#030305" }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at 50% 10%, rgba(0,243,255,0.05) 0%, transparent 70%)" }} />
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-xs font-rajdhani font-700 tracking-widest"
               style={{ background: "rgba(0,243,255,0.08)", border: "1px solid rgba(0,243,255,0.2)", color: "#00F3FF" }}>
            <Shield size={14} /> ENTERPRISE DATA PROTECTION
          </div>
          <h1 className="font-orbitron font-700 text-4xl md:text-6xl text-white mb-6 tracking-tight">
            Backup & Disaster <br />
            <span className="text-gradient">Recovery (BaaS & DRaaS)</span>
          </h1>
          <p className="font-outfit text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10" style={{ fontWeight: 300 }}>
            Powered by Veeam Enterprise Software. Secure your Public Cloud and On-Premises Servers
            with reliable S3 backup storage directly in IndiaCloud Datacenters.
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <div className="relative rounded-3xl overflow-hidden glass p-8 md:p-12 text-center"
               style={{ border: "1px solid rgba(188,19,254,0.3)", boxShadow: "0 20px 50px rgba(188,19,254,0.15)" }}>
            
            {/* Background effects */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#BC13FE] rounded-full blur-[100px] opacity-20 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#00F3FF] rounded-full blur-[100px] opacity-20 pointer-events-none" />
            
            <div className="relative z-10">
              <div className="inline-block px-4 py-1.5 rounded-full text-xs font-rajdhani font-700 tracking-wider mb-6"
                   style={{ background: "linear-gradient(135deg, #00F3FF, #BC13FE)", color: "#030305" }}>
                MOST POPULAR PLAN
              </div>
              <h2 className="font-orbitron font-700 text-3xl text-white mb-2">Veeam Enterprise Backup</h2>
              <p className="font-outfit text-gray-400 mb-8">All-in-one protection for modern workloads</p>
              
              <div className="flex justify-center items-end gap-2 mb-8">
                <span className="font-rajdhani font-700 text-5xl md:text-7xl text-white">₹1,999</span>
                <span className="font-outfit text-xl text-gray-500 mb-2">/month</span>
              </div>

              <div className="bg-[#0A0A12] rounded-2xl p-6 text-left mb-8 border border-white/5 relative z-20">
                <ul className="space-y-4">
                  {[
                    "1 TB IndiaCloud DC S3 Backup Storage",
                    "Powered by Veeam Enterprise Software",
                    "Public Cloud Infrastructure Backup",
                    "On-Premises Servers Backup",
                    "Disaster Recovery as a Service (DRaaS) Ready",
                    "End-to-end Encryption (In-flight & At-rest)",
                    "Human Support 24x7"
                  ].map((feature, i) => (
                    <li key={i} className="flex items-start gap-4">
                      <div className="w-5 h-5 rounded-full bg-[rgba(0,243,255,0.1)] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <CheckCircle size={12} color="#00F3FF" />
                      </div>
                      <span className="font-outfit text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/contact" className="no-underline block">
                <button className="w-full py-4 rounded-xl font-rajdhani font-700 text-lg transition-all duration-300 hover:scale-[1.02]"
                        style={{ background: "linear-gradient(135deg, #00F3FF, #BC13FE)", color: "#030305", boxShadow: "0 10px 30px rgba(188,19,254,0.3)" }}>
                  DEPLOY BACKUP SOLUTION
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Features Grid */}
      <section className="py-20 section-bg">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: Cloud, title: "Public Cloud Ready", desc: "Easily connect and backup your existing AWS, Azure, or DO workloads natively into IndiaCloud's secure environment." },
              { icon: Server, title: "On-Premises Protection", desc: "Seamlessly backup physical servers and internal infrastructure utilizing Veeam's industry-leading technology." },
              { icon: Zap, title: "Instant DRaaS Setup", desc: "Reduce Recovery Time Objectives (RTO) with blazing-fast S3 storage and immediate spin-up capabilities during disasters." }
            ].map((ft, i) => (
              <div key={i} className="glass p-8 rounded-2xl border border-white/5 hover:border-[rgba(0,243,255,0.3)] transition-all duration-300">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
                     style={{ background: "rgba(0,243,255,0.1)" }}>
                  <ft.icon size={24} color="#00F3FF" />
                </div>
                <h3 className="font-orbitron font-600 text-xl text-white mb-3">{ft.title}</h3>
                <p className="font-outfit text-gray-400 leading-relaxed font-300">{ft.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
